import { IEntityMetaData, IPropretyAttribute } from "../../_models/IEntityMetaData";
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { NavigationProperty, PropretyAttributes, Validation } from "../../decorators/EntityDecorators";
import { Register } from "../../decorators/DependencyInjectionRegistreyDecorators";
import { AccountBase } from "../AccountBase.model";
import { Role } from "../matwins-tenant/Role.model";
import { RegexType } from "../../services/RegexPatternLibrary";


@Register({
  isModelEntity: true, namespace: 'Manager', entityName: 'Account' // optionnel car par defaut utilise le nom de classe
})
export class Account extends AccountBase {

  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.FilterColumn,
      IPropretyAttribute.SortColumn
    ]
  })
  name!: string;

  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.FilterColumn,
      IPropretyAttribute.SortColumn
    ]
  })
  tenantPrefix!: string;

  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.FilterColumn,
      IPropretyAttribute.SortColumn
    ]
  })
  email!: string;

  @Validation({ maxLength: 50 })
  phoneNumber?: string;

  @PropretyAttributes({ attributes: [] })
  twoFactorEnabled: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.RequiredOnlyCreation] })
  @Validation({
    propertyType: RegexType.StrongPassword,
    minLength: 8
  })
  password!: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.CrossValidation] })
  @Validation({
    propertyType: RegexType.CrossValidation,
    crossValidationFieldName: 'password'
  })
  confirmPassword!: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fK_i18nLanguage!: number;

  override GetType(): IEntityMetaData {
    return Account.getMetaData();
  }


  static override getMetaData(): IEntityMetaData {
    const baseMetaData = super.getMetaData();
    return {
      ...baseMetaData,
      EndPoint: "/managerAccounts"
    };
  }
}
